import { SaveOutlined } from '@ant-design/icons'
import { Button, Input, Modal } from 'antd'
import { useEffect, useState } from 'react'

interface SaveReportButtonInterface {
  saveReport: (title: string) => void
  validate: () => Promise<any>
  title?: string
  modalVisible: boolean
  setModalVisible: (modalVisible: boolean) => void
  editMode: boolean
}

const SaveReportButton = ({
  saveReport,
  validate,
  title,
  modalVisible,
  setModalVisible,
  editMode,
}: SaveReportButtonInterface) => {
  const [reportName, setReportName] = useState('')

  useEffect(() => {
    setReportName(title || '')
  }, [title])

  const handleSaveClick = () => {
    validate()
      .then(() => setModalVisible(true))
      .catch(() => void 0)
  }

  const handleModalOk = () => {
    saveReport(reportName)
    setModalVisible(false)
  }

  return (
    <>
      <Button type="primary" ghost style={{ width: '120px', fontSize: '12px' }} onClick={handleSaveClick}>
        <SaveOutlined /> {'Save Report'}
      </Button>

      <Modal
        title={'Save Report'}
        open={modalVisible}
        onOk={handleModalOk}
        onCancel={() => setModalVisible(false)}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{ style: { width: 90 } }}
        cancelButtonProps={{ style: { width: 90 } }}
      >
        <label
          htmlFor="reportTitle"
          style={{
            display: 'block',
            fontWeight: '500',
            marginBottom: 8,
          }}
        >
          Report Title
        </label>
        <Input
          id="reportTitle"
          placeholder="Enter Title"
          autoComplete="off"
          value={reportName}
          onChange={(e) => setReportName(e.target.value)}
        />
      </Modal>
    </>
  )
}

export default SaveReportButton
